<template>
  <div class="card card-body bg-light mb-3">
    <div class="h3 mb-2 fw-bold mt-4">Loading model...</div>
    <div class="progress mb-5">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingAlert"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
